import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramCompareFollowers.graphql';
import { Query, QueryinstagramCompareFollowersArgs } from '../../__generated__/globalTypes';

export const useInstagramCompareFollowersQuery = (
  options?: QueryHookOptions<Query, QueryinstagramCompareFollowersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramCompareFollowersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramCompareFollowersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramCompareFollowersArgs>
): QueryResult<Query, QueryinstagramCompareFollowersArgs> & {
  getInstagramCompareFollowers: LazyQueryExecFunction<Query, QueryinstagramCompareFollowersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramCompareFollowers, result] = useLazyQuery<Query, QueryinstagramCompareFollowersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramCompareFollowers, ...result };
};

export const useInstagramCompareFollowersPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramCompareFollowers = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramCompareFollowersArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramCompareFollowersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramCompareFollowers };
};
// Suspense Query Hooks
export const useInstagramCompareFollowersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramCompareFollowersArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramCompareFollowersArgs>(QUERY, {
    ...options
  });

  return result;
};
